import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import BoxedContent from '../../components/BoxedContent'
import { CardProps } from '../../components/Card'
import { ActionButtonProps } from '../../components/ActionButton'
import { AcceptTermsProps } from '../../components/forms/DeclarationForm/AcceptTerms'

import * as SC from './styled'

export type HomeTemplateProps = {
  className?: string
  layoutProps?: DefaultLayoutProps
  background: string
  hasToOptin?: boolean
  acceptTerms?: AcceptTermsProps
  card?: CardProps & { button?: ActionButtonProps; innerTitle: string }
}

const HomeTemplate: FC<HomeTemplateProps> = ({
  layoutProps,
  background,
  card,
  acceptTerms,
  hasToOptin,
}) => {
  return (
    <DefaultLayout {...layoutProps}>
      <SC.Background $background={background}>
        <BoxedContent>
          {!hasToOptin && card && (
            <SC.CardWrapper {...card}>
              <SC.InnerTitle>{card.innerTitle}</SC.InnerTitle>
              <SC.Button {...card.button} />
            </SC.CardWrapper>
          )}
          {hasToOptin && acceptTerms && <SC.AcceptTerms {...acceptTerms} />}
        </BoxedContent>
      </SC.Background>
    </DefaultLayout>
  )
}

export default HomeTemplate
